import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommunicationService } from '../../communication/communication.service';
import { ProjectCommunicationService } from '../../communication/project-comms.service';
import { ConfiguredToastrService } from '../toastr/configured-toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { GetNameDialogComponent } from '../../results/results-helper/get-name.dialog';
import { take, takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../translation/anessa-translation.service';
import { AnessaTranslationInterface } from '../../models/interfaces/anessa-translation.interface';
import Utils from '../../util';
import { UserpilotReloader } from '../userpilot-reloader.component';

export interface DialogData {
  name: string;
  saveClicked: boolean;
}

@Component({
  selector: 'app-result-table',
  templateUrl: './result-table.component.html',
  styleUrls: ['./result-table.component.scss', '../../results/results-helper/universal-styling.scss']
})
export class ResultTableComponent extends UserpilotReloader implements OnInit, OnChanges, OnDestroy, AnessaTranslationInterface {

  // ResultSet | ResultSet[]
  @Input() tableData: any;
  @Input() tableHeaders: any;
  @Input() showTableSeparators = false;
  @Input() showFirstColumnSeparator = false;
  @Input() isProjectInput = false;
  @Input() isResultsLoaded = false;
  @Input() isEditable = false;
  @ViewChild('tableBody') tableBody?: ElementRef<HTMLDivElement>;
  results: any;
  tableName: string | null = null;
  indexes = [];
  selected = [];
  showTable = false;

  editColumn?: string;
  editRow?: number;

  onDestroyNotifier = new EventEmitter();
  trigger?: string;

  constructor(
    private commService: CommunicationService,
    private projectService: ProjectCommunicationService,
    private toasterService: ConfiguredToastrService,
    public dialog: MatDialog,
    private translationService: AnessaTranslationService
  ) {
    super();
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(language => {
        this.trigger = language;
      });
  }


  ngOnChanges() {
    this.showTable = !(this.tableData == null || this.tableData.length === 0);
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

 

  isTotalRow(name: string) {
    return name.includes('total  ') || name.includes(':  ');
  }

  formatDecimalPlaces(input: any): string {
    if (input === ' ' || input === undefined || input === null) {
      return input;
    }
    let displayValue: string;
    const precision = this.projectService.getPrecision();
    if (precision && precision > -1) {
      displayValue = String(Utils.roundToPrecisionFixed(input, precision));
    } else {
      displayValue = input.toString();
    }
    // Add commas e.g. 12345.6789 -> 12,345.6789
    if (displayValue != null) {
      const numberComponents = displayValue.split('.');
      const leftSide = numberComponents[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      numberComponents.splice(0, 1, leftSide);
      displayValue = numberComponents.join('.');
    }
    return displayValue;
  }

  numberCheck(input: any): boolean {
    return !isNaN(Number(input));
  }

  allowEdit(row: number, col: string) {
    return this.isEditable && this.editRow === row && this.editColumn === col;
  }

  edit(row: number, col: string) {
    this.editRow = row;
    this.editColumn = col;
  }

  openDialog(isSaveToReport: boolean): void {
    const dialogRef = this.dialog.open(GetNameDialogComponent, {
      width: '500px',
      data: { name: this.tableName, instruction: this.translationService.get('RESULTS.GENERAL.INPUT_TABLE_NAME') }
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(result => {
      if (result !== undefined) {
        this.tableName = result['name'];
          this.exportTableToCSV();
        
      }
    });
  }

  exportTableToCSV() {
    if (this.tableBody && this.tableName != null && this.tableName !== '') {
      const csv = [];
      const rows = this.tableBody.nativeElement.querySelectorAll('tr');

      for (let i = 0; i < rows.length; i++) {
        const row = [];
        const cols = <NodeListOf<HTMLElement>>rows[i].querySelectorAll('td, th');

        for (let j = 0; j < cols.length; j++) {
          if (cols[j].innerText != null) {
            row.push(cols[j].innerText.replace(/,/g, ''));
          } else {
            row.push('');
          }
        }
        csv.push(row.join(','));
      }

      this.downloadCSV(csv.join('\n'), this.tableName + '.csv');
    }
  }

  downloadCSV(csv: string, filename: string) {
    let csvFile = new Blob([csv], { type: 'text/csv' });
    let downloadLink = document.createElement('a');
    downloadLink.download = filename;

    // Create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);

    // Hide download link
    downloadLink.style.display = 'none';

    // Add the link to DOM
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
}
